import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { getDatabase, ref, set, push, child, get, onValue } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyApdfFiTeJ_-DtGLSqqSbU_O363ul0PP7U",
  authDomain: "menzill-371713.firebaseapp.com",
  projectId: "menzill-371713",
  storageBucket: "menzill-371713.firebasestorage.app",
  messagingSenderId: "718147406855",
  appId: "1:718147406855:web:370b9833304b92519e6ea2",
  measurementId: "G-Q1L1N72VCH"
};

// to access database
const app = initializeApp(firebaseConfig);
const firestore = getFirestore();
const db = getDatabase();

// const db = firebaseApp.firestore();

// const auth = firebase.auth()

const firebaseMessaging = getMessaging(app);

const fetchToken = async (setTokenFound) => {

  console.log(setTokenFound);
  return getToken(firebaseMessaging, {
    vapidKey: "BJvQEU4_DPCxEmISTpktBwo3QtAzAoj8u5j6SVDdA16Cf_QswTtMiuOi6dr-oQ90WW5-IeGUbLvxzzlCirvWxfQ",
  })
    .then((currentToken) => {
      if (currentToken) {
        // console.log('current token for client: ', currentToken);
        setTokenFound(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        // console.log('No registration token available. Request permission to generate one.');
        setTokenFound(currentToken);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};
// const requestForToken = () => {
//   return getToken(firebaseMessaging, { vapidKey: `BH9x5FVAN-Nev8wUZW12_GL14jGnmYBtsj-xXPPhY5X-gthO97tPvxv6_V227cBGpY6Qhj9keLij9keS7t3RiMo` })
//     .then((currentToken) => {
//       if (currentToken) {
//         console.log('current token for client: ', currentToken);
//         // Perform any other neccessary action with the token
//       } else {
//         // Show permission request UI
//         console.log('No registration token available. Request permission to generate one.');
//       }
//     })
//     .catch((err) => {
//       console.log('An error occurred while retrieving token. ', err);
//     });
// };

const onMessageListener = (callback) => onMessage(firebaseMessaging, callback);
const FCM_KEY = "BJvQEU4_DPCxEmISTpktBwo3QtAzAoj8u5j6SVDdA16Cf_QswTtMiuOi6dr-oQ90WW5-IeGUbLvxzzlCirvWxfQ";

export { firestore, db, app, fetchToken, onMessageListener, FCM_KEY };
